import { axiosClient } from '@/api/http/axios-client';
import type {
  ConnectTokenResponse,
  ExchangeCodeParams,
  LogoutForgetResponse,
  OAuthStatusResponse,
  SyncUserParams,
} from './google.interface';

async function getOauthStatus(): Promise<OAuthStatusResponse> {
  const { data } = await axiosClient.get<OAuthStatusResponse>('/oauth/google/status');
  return data;
}

async function getConnectToken(): Promise<ConnectTokenResponse> {
  const { data } = await axiosClient.post<ConnectTokenResponse>('/oauth/google/connect-token', {});
  return data;
}

async function exchangeCode(params: ExchangeCodeParams): Promise<void> {
  await axiosClient.post('/oauth/google/exchange-code', params);
}

async function disconnect(): Promise<void> {
  await axiosClient.post('/oauth/google/disconnect', {});
}

async function logoutAndForget(): Promise<LogoutForgetResponse> {
  const { data } = await axiosClient.post<LogoutForgetResponse>('/auth/logout-forget', {});
  return data;
}

async function syncUser(params: SyncUserParams): Promise<void> {
  await axiosClient.post('/auth/user', params);
}

export const GoogleApi = {
  getOauthStatus,
  getConnectToken,
  exchangeCode,
  disconnect,
  logoutAndForget,
  syncUser,
};
